/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SignupWizardFeatureModule } from './signup-wizard-feature/signup-wizard-feature.module';
import { SignupUserFeatureModule } from './signup-user-feature/signup-user-feature.module';

@NgModule({
  imports: [
    CommonModule,
    SignupWizardFeatureModule,
    SignupUserFeatureModule,
    RouterModule.forChild([
      { path: '', pathMatch: 'full', redirectTo: 'step' },
      {
        path: 'step',
        loadChildren: () => SignupWizardFeatureModule,
      },
      {
        path: 'user-signup',
        loadChildren: () => SignupUserFeatureModule,
        data: [{ logout: true }],
      }
    ])
  ],
})
export class SignupModule {}
